
import {
    CORE_LOAD_ALL_DISPLAY_REQUEST,
    CORE_LOAD_ALL_DISPLAY_SUCCESS,
    CORE_LOAD_ALL_DISPLAY_FAILURE,


    CORE_FIND_DISPLAY_INFO_REQUEST,
    CORE_FIND_DISPLAY_INFO_SUCCESS,
    CORE_FIND_DISPLAY_INFO_FAILURE,
} from '../types'

import ActionResourceArray from '../../core/ActionResourceArray'
import ActionResourceObject from '../../core/ActionResourceObject'
import DisplayModel from '../../model/displayModel'
export default {
    allDisplay: (state, action) => {
        if (!state) {
            state = new ActionResourceArray()
        }

        switch (action.type) {
            case CORE_LOAD_ALL_DISPLAY_REQUEST:
                state.setStatus(state.REQUEST)
                state.setValue(null)
                break
            case CORE_LOAD_ALL_DISPLAY_SUCCESS:
                state.setStatus(state.REQUEST_SUCCESS)
                if (action.payload && action.payload.result == true) {
                    state.setValue(action.payload.datas)
                } else {
                    state.setValue([])
                }

                break
            case CORE_LOAD_ALL_DISPLAY_FAILURE:
                state.setStatus(state.REQUEST_FAILURE)
                state.setValue(action.payload)
                break
            default:
                state.setStatus(state.NO_ACTION)
                // state.setValue(null)
                break
        }

        return state
    },
    display: (state, action) => {
        if (!state) {
            state = new ActionResourceObject()
        }

        switch (action.type) {
            case CORE_FIND_DISPLAY_INFO_REQUEST:
                state.setStatus(state.REQUEST)
                state.setValue(null)
                break
            case CORE_FIND_DISPLAY_INFO_SUCCESS:
                if (action.payload && action.payload.result == true) {
                    state.setStatus(state.REQUEST_SUCCESS)
                    state.setValue(action.payload.data)
                } else {
                    state.setStatus(state.REQUEST_FAILURE)
                    state.setValue(action.payload)
                }
                break
            case CORE_FIND_DISPLAY_INFO_FAILURE:
                state.setStatus(state.REQUEST_FAILURE)
                state.setValue(action.payload)
                break
            default:
                state.setStatus(state.NO_ACTION)
                // state.setValue(null)
                break
        }

        return state
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerDisplay.js